<template>
<div class="card">
  <a-alert
      :message="accountInfo.status|statusF"
      type="info"
      show-icon
      description=""
    />
  <div class="search-box">
    <span class="header">结算单信息</span>
    <div class="item">
      <span><label>结算编号：</label>{{accountInfo.applyNum}}</span>
      <span><label>申请时间：</label>{{accountInfo.createTime}}</span>
      <span><label>合计金额：</label>{{accountInfo.withdrawAmount|toFixed2}}</span>
    </div>
  </div>
  <div class="certificate-box" v-show="accountInfo.status!=10&&accountInfo.status!=15">
    <span class="header">结算凭证</span>
    <div class="item pic-item">
      <div class="left-pic"><label>发票凭证：</label>
        <a-upload disabled list-type="picture-card" :file-list="picList" @preview="handlePreview"></a-upload>
      </div>
      <div class="right-pic"><label>付款凭证：</label>
        <a-upload list-type="picture-card" :file-list="fileList" @preview="handlePreview" :disabled="accountInfo.status!=40" @change="handleChange" :before-upload="beforeUpload">
          <div v-if="fileList.length < 10&&accountInfo.status==40">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传照片
            </div>
          </div>
        </a-upload>
      </div>
    </div>
  </div>
  
  <div class="list" style="background:rgba(255,255,255,1); padding:24px">
    <span class="header">相关订单</span>
		<order-list :data="data" :pagination="pagination" orderType="7"></order-list>
  </div>
  <div class="btn-box" v-show="accountInfo.status=='10'||accountInfo.status=='30'||accountInfo.status=='40'">
      <div v-show="accountInfo.status =='10'">
        <a-button type="primary" @click="check(1)">核账通过</a-button>
        <a-button @click="check(0)">核账不通过</a-button>
      </div>
      <div v-show="accountInfo.status =='30'">
        <a-button type="primary" @click="checkStatus(1)">核验通过</a-button>
        <a-button  @click="checkStatus(0)">核验不通过</a-button>
      </div>
      <div v-show="accountInfo.status =='40'">
          <a-button type="primary" @click="uploadProof">提交</a-button>
      </div>
    </div>
  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</div>
  
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
import page from "@/assets/mixin/page.js";
import {settleApplyUploadProof} from "@/api/capital"
import OrderList from "@/components/OrderList";
export default {
  components:{OrderList},
  mixins: [page],
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: [],
      picList:[],
      data:[],
      accountInfo:{},
      pagination: {
        total:0,
        current:1,
        pageSize:10,
        onChange: page => {
          this.pagination.current = page;
          this.getdata && this.getdata();
        },
      },
    };
  },
   filters:{
		statusF(value){
      switch (value) {
        case 10: return '待核账'     ;break;
        case 15: return '核账不通过' ;break;
        case 20: return '发票待上传' ;break;
        case 30: return '发票待核验' ;break;
        case 35: return '核验不通过' ;break;
        case 40: return '凭证待上传' ;break;
        case 50: return '已结算'     ;break;
      }
    }
   },
  activated(){
      let meta = this.$route.meta;
      if (!meta.keepAlive) {
        this.pagination.current = 1;
        this.getdata();
      }
  }, 
  beforeRouteEnter(to,from,next){
      if(from.name !== 'order-after'){//不是从detail页面过来的，需要刷新
          to.meta.keepAlive = false;
      }else{
        to.meta.keepAlive = true;
      }
      next()
  },
  beforeRouteLeave(to,from,next){
    if(to.name !== 'order-after') {//不去详情页面时，将缓存的listData数组清空
        this.data = []
        this.accountInfo = {}
    }
    next()
  },
  methods:{
    uploadimg(val) {
      let formdata = new FormData();
      formdata.append("imgFile", val.originFileObj);
      return this.$http.post("settleApply/preUploadImg", formdata);
    },
    //主营系统上传付费凭证。
    async uploadProof(){
			const key = 'updatable';
			this.$message.loading({ content: '上传中...', key });
      let invoiceFiles=[]
      for (
        let index = 0;
        index < this.fileList.length;
        index++
      ) {
        if (this.fileList[index].url) {
          invoiceFiles.push( this.fileList[index].url);
        }else{
          await this.uploadimg(this.fileList[index]).then((res) => {
          invoiceFiles.push( res.data.filepath);
        });
        }
      }
      settleApplyUploadProof({settleId :this.$route.query.id},invoiceFiles).then(res=>{
        if (res.result) {
					this.$message.success({ content: '操作成功!', key, duration: 2 });
          this.$router.go(-1);
        } else {
          this.$message.warning(res.message)
        }
        
      })
    },
    checkStatus(index){
      let params = {
        checkStatus  : index,
        settleId :this.$route.query.id,
      }
      this.$http.post('settleApply/checkInvoice','',{params}).then(res=>{
        if (res.result) {
          this.$message.success('操作成功');
          this.$router.go(-1)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //图片相关
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    //图片结束
    getdata(){
      let params = {
        pageNum : this.pagination.current,
        settleId :this.$route.query.id,
      }
      this.$http.get('settleApply/querySettleOrder',{params}).then(res=>{
        this.data = res.rows
        this.accountInfo = res.data;
        if (this.accountInfo.invoicePathSet&&this.accountInfo.invoicePathSet.length>0) {
          let picList = this.accountInfo.invoicePathSet.map((item,index)=>{return{
            uid:index,
            url:item,
            status:'done',
            name: 'image.png',
          }
          })
          this.picList = picList; 
        }
        if (this.accountInfo.payProofPathSet&&this.accountInfo.payProofPathSet.length>0) {
          let fileList = this.accountInfo.payProofPathSet.map((item,index)=>{return{
            uid:index,
            url:item,
            status:'done',
            name: 'image.png',
          }
          })
          this.fileList = fileList; 
        }
        
        this.pagination.total = res.count;
      })
    },
    //核账通过不通过
    check(index){
      let params = {
        settleId : this.$route.query.id,
        checkStatus : index
      }
      this.$http.post('settleApply/checkAmount','',{params}).then(res=>{
        if (res.result) {
          this.$message.success('操作成功');
          this.$router.go(-1)
        }else{
          this.$message.warning(res.message);
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>

/deep/.ant-modal-wrap {
  .ant-modal{
    width: 720px!important;
  }
}

/deep/.ant-modal-body {
    padding: 0;
}

.list{
  .header{
    display: inline-block;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
    margin-bottom: 16px;
  }
}
.card{
  // position: relative;
  margin:0 24px;
  // padding: 24px;
}
/deep/.ant-list-lg .ant-list-item {
    padding-top: 0;
}

.certificate-box{
  padding: 29px 24px;
  margin-bottom: 24px;
  background:rgba(255,255,255,1);
  .header{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
  }
    .left-pic,.right-pic{
      margin-top: 16px;
      display: inline-block;
      width: calc((100%-10px)/2);
      label{
        width: 70px;
        vertical-align: top;
      }
      /deep/.ant-upload-picture-card-wrapper{
        width: 80%;
        display: inline-block;
      }
  }
  .pic-item{
    font-size:14px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    span{
      vertical-align: top;
    }
  }
}

.search-box{
  margin-top: 16px;
  background:rgba(255,255,255,1);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .header{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
  }
  span{
      display: inline-block;
      padding: 8px 0 ;
    }
  .item{
    span{
      padding-right:180px;
    }
  }
  
}


.ant-list-split .ant-list-item {
    border: 1px solid #e8e8e8;
    // border-bottom: 0;
    margin-bottom: 12px;
}
/deep/.ant-list-split .ant-list-header {
    /* border-bottom: 1px solid #e8e8e8; */
    margin-bottom: 12px;
    background-color: #FAFAFA;
}

.btn-box{
  box-shadow:0px 9px 28px 8px rgba(0,0,0,0.05),0px 6px 16px 0px rgba(0,0,0,0.08),0px 3px 6px -4px rgba(0,0,0,0.12);
  border-radius:2px;
  margin-top: 16px;
  bottom: 0;
  background-color: #fff;
  height: 64px;
  display: flex;
  display: -webkit-flex;
  align-items:center;
  justify-content:center;
  .ant-btn-primary{
    margin-right: 16px;
  }
}
.order-detail{
    display: flex;
    // justify-content: center;
    align-items: center;
}
</style>
